import { VALID_CARD_NUMBER_FORMAT } from '@engine/constants'; // Constant to represent the multiplier for converting a decimal amount into an integer
// to avoid floating-point precision issues during calculations

var DECIMAL_ADJUSTMENT = 100; // This is debouncing time

var USER_INPUT_DELAY = 800; // Installments are only for the following transaction types

var TRANSACTIONS_WITH_INSTALLMENTS = ['sale', 'sale3d', 'authorize', 'authorize3d'];

var Installments = function () {
  var contract = null;
  var userInputTimeout = null;
  var initFlag = false;

  var isCardNumberFormatValid = function isCardNumberFormatValid(number) {
    var regex = new RegExp(VALID_CARD_NUMBER_FORMAT);
    return regex.test(number);
  };

  var addInstallmentPlanOptionsToDropdown = function addInstallmentPlanOptionsToDropdown(selector, options) {
    options.forEach(function (object) {
      var option = $('<option/>').attr('value', object.id).text(object.name);
      selector.append(option);
    });
  };

  var toggleInstallmentPlansSelect = function toggleInstallmentPlansSelect(plans) {
    var emptyValue = '<option value="">' + I18n.t('javascript.options.installments.pay_in_full') + '</option>';
    var $installmentPlansSelector = $('#installment_plans_selection');
    var $select = $installmentPlansSelector.find('select');
    var $installmentPlanGrouping = $('#installment_plan_grouping_id');
    $select.empty();
    $installmentPlanGrouping.val('');

    if (plans.length === 0) {
      $installmentPlansSelector.addClass('hidden');
    } else {
      $select.append(emptyValue);
      addInstallmentPlanOptionsToDropdown($select, plans);
      $('.for_chosen').trigger('chosen:updated');
      $installmentPlansSelector.removeClass('hidden');
      $installmentPlanGrouping.val(plans[0].grouping_id);
    }
  };

  var getAmount = function getAmount() {
    var wholeAmount = $('#whole_amount').val();
    var decimalAmount = $('#decimal_amount').val();
    return Number("".concat(wholeAmount, ".").concat(decimalAmount)) * DECIMAL_ADJUSTMENT;
  };

  var reset = function reset() {
    toggleInstallmentPlansSelect([]);
  };

  var handleValuesChanged = function handleValuesChanged() {
    var _contract, _contract$features;

    var $terminalSelect = $('input[name$="_transaction[terminal_id]"]');
    var form_action = $terminalSelect.closest('form').attr('action');
    var trx_type = form_action === null || form_action === void 0 ? void 0 : form_action.replace(/.*?virtual-terminal\/(\w*).*/i, '$1');

    if (!((_contract = contract) !== null && _contract !== void 0 && (_contract$features = _contract.features) !== null && _contract$features !== void 0 && _contract$features.supports_installments) || !TRANSACTIONS_WITH_INSTALLMENTS.includes(trx_type === null || trx_type === void 0 ? void 0 : trx_type.toLowerCase())) {
      reset();
      return;
    }

    var cardNumber = $('input[name*=card_number]').val();
    var terminal_id = $terminalSelect.val();
    clearTimeout(userInputTimeout);

    if (typeof cardNumber === 'undefined' || typeof terminal_id === 'undefined') {
      reset();
      return;
    }

    userInputTimeout = setTimeout(function () {
      if (isCardNumberFormatValid(cardNumber)) {
        $.ajax({
          type: 'POST',
          url: "/installments/plans/".concat(terminal_id),
          data: {
            amount: getAmount(),
            card_number: cardNumber
          },
          success: function success(data) {
            var _data$installment_pla;

            return toggleInstallmentPlansSelect((_data$installment_pla = data.installment_plans) !== null && _data$installment_pla !== void 0 ? _data$installment_pla : []);
          }
        });
      } else {
        reset();
      }
    }, USER_INPUT_DELAY);
  };

  var ensureHandleValuesChange = function ensureHandleValuesChange() {
    if ($('#installment_plans_selection').is(':visible') && !initFlag) {
      initFlag = true;
      return false;
    }

    return true;
  };

  var setup = function setup(newContract) {
    contract = newContract;

    if (ensureHandleValuesChange()) {
      handleValuesChanged();
    }
  };

  var listenForChanges = function listenForChanges() {
    $('input[name*=card_number], #whole_amount, #decimal_amount').on('change keyup', function () {
      initFlag = true;
      handleValuesChanged();
    });
  };

  return {
    setup: setup,
    listenForChanges: listenForChanges
  };
}();

export default Installments;